import { Activityeditor } from '@linktivity/link-connect';
import config from '../config';

const contractApi = new Activityeditor.ContractApi(config);

export default contractApi;
